
<div class="p-6 bg-white">
    <div id="pdfContent" class="max-w-4xl p-8 mx-auto my-6 border shadow-sm print:p-0" style="color: black; font-family: 'Inter', system-ui, -apple-system, sans-serif;">
      <header class="flex flex-col items-center gap-6 mb-8 sm:flex-row sm:items-start">
        <div class="w-40">
          <!-- logo optional -->
          <img src="/assets/icon/ancLogo.jpeg" alt="logo" class="w-40 h-auto" onerror="this.style.display='none'">
        </div>
        <div class="flex flex-col items-center flex-1 gap-3 text-center">
          <h1 class="text-xl font-extrabold text-green-700">ALL NIGERIA COMMUNITY GHANA</h1>
          <div class="text-sm text-gray-700">22 Achimota-Legon Road, behind pure fire, Kisseman</div>
          <div class="text-sm text-gray-700">TEL: 024 484 4081</div>
          <div class="mt-1 font-bold text-red-600">MOTTO: One Nation, One People</div>
          <div class="px-3 py-1 mt-2 text-white bg-green-600 rounded">MEMBERSHIP REGISTRATION FORM</div>
          <div class="flex flex-col justify-between w-full gap-2 sm:flex-row sm:gap-0">
            <div>
              <label class="mr-3 font-bold">SERIAL NO:</label>
              <input size="5" title="Serial number" [value]="sessionService.formSubData()?.user?.serial_number"
                class="px-4 py-3 transition duration-150 ease-in-out border rounded-lg "
                readonly />
            </div>

            @if(sessionService.formSubData()?.anc_policy){
            <div >
              <label class="mr-3 font-bold">POLICY NO:</label>
              <input size="13" title="Serial number" [value]="sessionService.formSubData()?.anc_policy"
                class="px-4 py-3 transition duration-150 ease-in-out border rounded-lg "
                readonly />
            </div>
            }


          </div>
        </div>
        <div class="text-right w-28">
          <div class="flex items-center justify-center w-24 overflow-hidden border-2 h-28">

            @if(sessionService.formSubData()?.user?.passport_photo_url){
                <img [src]="sessionService.formSubData()?.user?.passport_photo_url" class="object-cover w-full h-full"
              alt="Passport Photo" />
            }@else {
                <span  class="text-xs">Photograph</span>
            }

          </div>
        </div>
      </header>


        <div hlmFieldGroup>
            <fieldset hlmFieldSet>
              <hlm-field-separator class="col-span-full" />
              <legend hlmFieldLegend>Personal Information</legend>

              <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2" style="break-inside: avoid;">
                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="fullName">Full Name</label>
                  <input
                    hlmInput
                    id="fullName "
                    type="text"
                    placeholder="John Doe"
                    [value]="sessionService.formSubData()?.user?.full_name"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="name_of_kvtl">NAME OF KIN, VILLAGE, TOWN, & LGA</label>
                  <input
                    hlmInput
                    id="name_of_kvtl"
                    type="text"
                    [value]="sessionService.formSubData()?.user?.name_of_kvtl"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="phoneNumber">PHONE NUMBER</label>
                  <input
                    hlmInput
                    id="phoneNumber"
                    type="tel"
                    maxlength="10"
                    pattern="^0\d{9}$"
                    [value]="sessionService.formSubData()?.user?.mobile_number"
                    placeholder="Phone Number (e.g., 0123456789)"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="dateOfBirth">DATE OF BIRTH</label>
                  <input
                    hlmInput
                    id="dateOfBirth"
                    type="text"
                    [value]="sessionService.formSubData()?.user?.date_of_birth"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="occupation">OCCUPATION</label>
                  <input
                    hlmInput
                    id="occupation"
                    type="text"
                    placeholder="Occupation"
                    [value]="sessionService.formSubData()?.user?.occupation"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="email">EMAIL</label>
                  <input
                    hlmInput
                    id="email"
                    type="email"
                    placeholder="Email Address"
                    [value]="sessionService.formSubData()?.user?.email"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="maritalStatus">Marital Status</label>
                  <input
                    hlmInput
                    id="maritalStatus"
                    type="text"
                    placeholder=""
                    [value]="sessionService.formSubData()?.user?.marital_status"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="region">Region</label>
                  <input
                    hlmInput
                    id="region"
                    type="text"
                    placeholder=""
                    [value]="sessionService.formSubData()?.user?.region"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>


                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="ghanaAddress">RESIDENTIAL ADDRESS IN GHANA</label>
                  <input
                    hlmInput
                    id="ghanaAddress"
                    type="text"
                    placeholder="Address in Ghana"
                    [value]="sessionService.formSubData()?.user?.ghana_address"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="nigeriaAddress">RESIDENTIAL ADDRESS IN NIGERIA</label>
                  <input
                    hlmInput
                    id="nigeriaAddress"
                    type="text"
                    placeholder="Address in Nigeria"
                    [value]="sessionService.formSubData()?.user?.nigeria_address"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="localGovernment">Local Gov't Area</label>
                  <input
                    hlmInput
                    id="localGovernment"
                    type="text"
                    placeholder="Local Government Area"
                    [value]="sessionService.formSubData()?.user?.local_government"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="stateOrigin">State of Origin</label>
                  <input
                    hlmInput
                    id="stateOrigin"
                    type="text"
                    placeholder="State of Origin"
                   [value]="sessionService.formSubData()?.user?.state_origin"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="refereesNames">Name of Referees in Ghana</label>
                  <input
                    hlmInput
                    id="refereesNames"
                    type="text"
                    placeholder="Names of Referees in Ghana"
                    [value]="sessionService.formSubData()?.user?.ghana_referee"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="refereesPhoneNumber">Phone Number of Referees</label>
                  <input
                    hlmInput
                    id="refereesPhoneNumber"
                    type="text"
                    placeholder="Phone Number of Referees"
                    [value]="sessionService.formSubData()?.user?.phone_referee"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="refereesAddress">Address of Referees</label>
                  <input
                    hlmInput
                    id="refereesAddress"
                    type="text"
                    placeholder="Address of Referees"
                   [value]="sessionService.formSubData()?.user?.address_referee"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>
              </div>
            </fieldset>

            <fieldset hlmFieldSet>
              <hlm-field-separator />
              <legend hlmFieldLegend>Details of Beneficiary</legend>

              <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2" style="break-inside: avoid;">
                <div hlmField>
                  <label hlmFieldLabel for="benNextOfKin">Next of Kin</label>
                  <input
                    hlmInput
                    id="benNextOfKin"
                    type="text"
                    placeholder="Next of Kin"
                    [value]="sessionService.formSubData()?.user?.next_of_kin"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="benRelationship">Relationship to Beneficiary</label>
                  <input
                    hlmInput
                    id="benRelationship"
                    type="text"
                    placeholder="Relationship to Beneficiary"
                    [value]="sessionService.formSubData()?.user?.kin_relationship"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>

                <div hlmField>
                  <label hlmFieldLabel for="benPhoneNumber">Contact</label>
                  <input
                    hlmInput
                    id="benPhoneNumber"
                    type="tel"
                    placeholder="Beneficiary Phone Number (e.g., 0123456789)"
                    [value]="sessionService.formSubData()?.user?.kin_contact_number"
                    maxlength="10"
                    pattern="^0\d{9}$"
                    class="w-full px-4 py-3 rounded-lg border "
                    readonly
                  />

                </div>
              </div>
            </fieldset>

            <fieldset hlmFieldSet>
              <hlm-field-separator />
              <legend hlmFieldLegend>Declaration</legend>

              <hlm-field-group style="break-inside: avoid;">
                <div hlmField orientation="horizontal" class="flex">
                  <!-- <div></div> -->
                  <hlm-checkbox [checked]="true"
                    inputId="declaration"
                    class="size-8 mr-2 data-checked:bg-[#B580D1] data-checked:border-[#B580D1]"
                    
                  />
                  <label hlmFieldLabel for="declaration">
                    I {{ sessionService.formSubData()?.user?.full_name }} solemnly declare the above particulars given by
                    me to be true in substance and material facts:
                  </label>
                </div>
              </hlm-field-group>
            </fieldset>


            <fieldset hlmFieldSet>
                <label hlmFieldLabel for="signature" class="font-bold">Signature</label>

                <div class="h-24">
                    <img  alt="Applicant Signature" [src]="sessionService.formSubData()?.user?.signature_photo_url" class="w-auto h-auto " onerror="this.style.display='none'">
              </div>
              <!-- <div id="signature" hlmAttachment   orientation="vertical">
            <div hlmAttachmentMedia variant="image" class="size-60">
              <img [src]="sessionService.formSubData()?.user?.signature_photo_url" alt="signature" class="object-contain! h-full w-full" onerror="this.style.display='none'">
            </div>
          </div> -->

            </fieldset>
          </div>




      <main class="space-y-3">



        <section class="mt-6">

          <div class="flex flex-row flex-wrap gap-6 mt-6">
          </div>
          <div class="mt-3">
            <div class="flex-1">
              <div class="font-bold">APPROVED BY CHAIRMAN</div>
              <div class="pt-2 mt-4 ">Name & Signature</div>
              <p>{{sessionService.formSubData()?.user?.approved_by}}</p>
            </div>
          </div>
        </section>
      </main>


      <!-- <footer class="mt-6 text-sm text-gray-700">
        <div class="z-50 px-2 pt-2 text-center">
          <div>© 2026 DrayTechits | All Rights Reserved</div>
        </div>
      </footer> -->
    </div>
  </div>
